import React, { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from "../../../utilities/TableUtil";
import { normalColumn, actionColumnCustomLableInfo } from "../../../components/DataTable/DataTable.js";
import * as bodyStyle from "../../../components/DataTable/ConsBodyStyle.js";

export default function P350List({ dataTable, searchData, goPage }) {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });

    // const header = (
    //     <div className="table-header">
    //         <h5></h5>
    //         <span className="p-input-icon-left span-responsive">
    //             <i className="pi pi-search" />
    //             <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="ค้นหา" />
    //         </span>
    //     </div>
    // );

    const actionBodyEdit = (rowData) => goPage("B", rowData);
    return (
        <div className="datatable-responsive-modify">
            <div className="card">
                <DataTable
                    // ref={(el) => dt = el}
                    value={dataTable}
                    dataKey="id"
                    paginator
                    first={pageConf.first}
                    rows={pageConf.rows} 
                    onPage={(e)=>onPageChange(e,setPageConf)}
                    rowsPerPageOptions={rowsPerPageOptions()}
                    paginatorTemplate={paginatorTemplate()}
                    currentPageReportTemplate={currentPageReportTemplate()}
                    // header={header}
                    globalFilter={globalFilter}
                    emptyMessage="ไม่พบข้อมูล"
                    className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                    selectionMode="single"
                >
                    <Column field="contractNo" header="เลขที่สัญญา" body={(e) => normalColumn(e, "contractNo", "เลขที่สัญญา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column field="routeNo" header="เส้นทาง" body={(e) => normalColumn(e, "routeNo", "เส้นทาง")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_LEFT_OVER} />
                    <Column field="inspectDt" header="เริ่มตรวจสอบเวลา" body={(e) => normalColumn(e, "inspectDt", "เริ่มตรวจสอบเวลา")} style={{ textAlign: "center", width: "10%" }} bodyStyle={bodyStyle.TXT_CENTER} />
                    <Column header="ดูรายละเอียด" body={(e) => actionColumnCustomLableInfo(e, actionBodyEdit, "กดเพื่อดูรายละเอียด", "fa fa-search")} style={{ textAlign: "center", width: "5%" }} bodyStyle={bodyStyle.TXT_CENTER}></Column>
                </DataTable>
            </div>
        </div>
    );
}
